import type { DocNode } from '@atlaskit/adf-schema/doc';

import type { FieldId } from '../form-fields';

export interface FormSection {
	readonly layout: DocNode;
	readonly condition?: FormSectionCondition;
}

export type FormSectionCondition = {
	checkGroups: FormSectionConditionCheckGroup[];
	visibility: Visibility;
	// applied to all groups
	operator: FormSectionConditionOperator;
};

export interface FormSectionConditionCheckGroup {
	// applied to all child checks
	operator: FormSectionConditionOperator;
	checks: FormSectionConditionCheck[];
}

export type FormSectionConditionCheck = {
	fieldId: FieldId;
	type: FormSectionConditionCheckType;
	constraint: string[];
};

// oxlint-disable-next-line eslint/no-redeclare
export const FormSectionConditionCheckType = {
	// Option checks:
	ALL_OF: 'ALL_OF',
	BETWEEN: 'BETWEEN', // Exclusive of `minimum` and `maximum`.
	CONTAINS: 'CONTAINS',
	DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
	NONE_OF: 'NONE_OF',
	SOME_OF: 'SOME_OF',
	// String contents checks - e.g. option label; file name; text; etc.
	// Relativity checks - field types: date and/or time; number; text; etc.
	DOES_NOT_EQUAL: 'DOES_NOT_EQUAL',
	EQUAL_TO: 'EQUAL_TO',
	GREATER_THAN: 'GREATER_THAN',
	GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
	LESS_THAN: 'LESS_THAN',
	LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
	EMPTY: 'EMPTY',
	NOT_EMPTY: 'NOT_EMPTY',
} as const;

export type FormSectionConditionCheckType =
	(typeof FormSectionConditionCheckType)[keyof typeof FormSectionConditionCheckType];

// oxlint-disable-next-line eslint/no-redeclare
export const FormSectionConditionOperator = {
	AND: 'AND',
	OR: 'OR',
} as const;

// oxlint-disable-next-line eslint/no-redeclare
export const Visibility = {
	SHOW: 'show',
	HIDE: 'hide',
} as const;

export type Visibility = (typeof Visibility)[keyof typeof Visibility];

export type FormSectionConditionOperator =
	(typeof FormSectionConditionOperator)[keyof typeof FormSectionConditionOperator];
